import React from "react";
import _ from "lodash";

import IColumn from "models/IColumn";
import { PictureAsPdf } from "components/Icons";
import { downloadDocument } from "helpers/download";
import { markAsRead } from "../app/actions";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    fixedWidth: 52,
    render: rowData => (
      <PictureAsPdf
        id={`download-inspection-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(
            rowData,
            () =>
              !_.get(rowData, "Read", true) &&
              markAsRead([rowData.Id], "Receipt")
          );
        }}
      />
    ),
    visible: true,
    notRowClick: true
  },
  {
    title: "RECEIPTS_NR",
    key: "Number",
    visible: true,
    isSortable: false
  },
  {
    title: "DATE",
    key: "Date",
    type: "date",
    visible: true
  },
  {
    title: "TYPE",
    key: "TypeId",
    visible: true
  },
  {
    title: "INSPECTION_DATE",
    key: "ArrivalDate",
    type: "date",
    visible: true
  },
  {
    title: "RECEIPTS_SUPPLIER",
    key: "SupplierName",
    visible: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "OrderNumber",
    visible: true
  }
];
